<template>
<div class="how_to_play_description">
  <div class="step">{{step}}</div>
  <div class="title">{{title}}</div>
  <slot></slot>
</div>

</template>
<script>
export default {
  name: 'HowToPlayDescription',
  props: {
    step: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
  },
};
</script>
<style lang="scss" scoped>
.how_to_play_description {
  max-width: 1080px;
  margin: 50px auto 0;
  .step {
    font-size: 30px;
    width: 130px;
    background-color: #3C4964;
    text-align: center;
  }
  .title {
    font-size: 35px !important;
    font-weight: bold;
    margin: 15px 0;
  }
  .description {
    margin-top: 5px;
  }
}
@media screen and (max-width: 768px){
  .how_to_play_description {
    max-width: 370px;
    margin: 20px auto 0;
    .step {
      font-size: 22px;
      width: 100px;
    }
    .title {
      font-size: 24px !important;
      font-weight: bold;
    }
  }
}
</style>
